






import { Component, Vue } from 'vue-property-decorator';
import OfferDetailPage from '@/views/Offers/OfferDetail/OfferDetail.vue';

@Component({
  components: {
    OfferDetailPage
  }
})
export default class OfferDetail extends Vue {}
